<div class="tray" *ngIf="badges.length">
    <ng-container *ngFor="let badge of badges|slice:0:(trayLimit)?trayLimit : badges.length">
        <div>
        <img src="../../../assets/images/placheholder_brand_image.png">
        </div>
    </ng-container>
    <ng-container *ngIf="trayLimit">
        <div class="plus-icon">
            +{{badges.length - trayLimit}}
        </div>
    </ng-container>
</div>